"use strict";
var ArrayObservable_1 = require('./ArrayObservable');
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/observable/of.js